import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';
import defaultTheme from './../../../../utils/styles/defaultTheme';
export default /*#__PURE__*/React.memo(function (props) {
  var _props$selectProps;
  var icon = /*#__PURE__*/React.createElement(Icon, {
    name: "lockOutline",
    size: "medium",
    color: defaultTheme.colors.neutral600
  });
  if (props !== null && props !== void 0 && (_props$selectProps = props.selectProps) !== null && _props$selectProps !== void 0 && _props$selectProps.lockIcon) {
    var _props$selectProps2;
    icon = props === null || props === void 0 || (_props$selectProps2 = props.selectProps) === null || _props$selectProps2 === void 0 ? void 0 : _props$selectProps2.lockIcon;
  }
  return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, icon);
});